"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.VectorManualFieldView = void 0;
exports.viewVectorManualEdit = viewVectorManualEdit;
var tslib_1 = require("tslib");
var core_api_1 = require("@ikegps/core-api");
var field_action_button_1 = require("../../../components/button/field.action.button");
var icons_1 = require("../../../components/icon/icons");
var input_1 = require("../../../components/input/input");
var vector_input_1 = require("../../../components/input/vector.input");
var vector_input_state_1 = require("../../../components/input/vector.input.state");
var notification_service_1 = require("../../../components/notification.toast/notification.service");
var theme_1 = require("../../../components/theme");
var index_1 = require("../../../i18n/index");
var mithril_1 = require("../../../mithril");
var services_1 = require("../../../services");
var page_state_1 = require("../../../state/page.state");
var field_info_1 = require("../../field.info/field.info");
var point_collection_cache_1 = require("../../topological.editor.map/point.collection.cache");
var CSS = {
    container: 'c-Vector',
    isLinked: 'c-Vector--linked'
};
(0, theme_1.addStyles)((_a = {},
    _a[CSS.isLinked] = {
        display: 'flex',
        'justify-content': 'flex-end'
    },
    _a));
function linkCollection(field, ctrl) {
    return tslib_1.__awaiter(this, void 0, void 0, function () {
        var collection;
        return tslib_1.__generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:start', field.schema.displayName, 1);
                    notification_service_1.NotificationService.info({ key: index_1.T.COLLECTION_LINK_START });
                    return [4 /*yield*/, ctrl.chooseLinkingCollection(field)];
                case 1:
                    collection = _a.sent();
                    if (collection == null) {
                        services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:cancel', field.schema.displayName, 1);
                        return [2 /*return*/];
                    }
                    if (collection.uuid === ctrl.collection.uuid) {
                        notification_service_1.NotificationService.warn({ key: index_1.T.COLLECTION_LINK_INVALID });
                        return [2 /*return*/];
                    }
                    field.Mutator.collection(collection.collectionId);
                    if (ctrl.kind === 'TopologicalEditorCollectionEditCtrl') {
                        point_collection_cache_1.TopologicalPointCollectionCache.addVector(ctrl.collectionEditState.collectionRevision, field);
                        ctrl.redrawMap();
                    }
                    services_1.Services.Analytics.trackEvent(services_1.Services.Analytics.EventCategory.Mutate, 'vector:link:success', field.schema.displayName, 1);
                    return [2 /*return*/];
            }
        });
    });
}
function viewVectorManualEdit(field, ctrl) {
    var inputState = ctrl.changeState.getState(field.id);
    if (!inputState) {
        var value = field.value;
        inputState = new vector_input_state_1.VectorInputState(field.schema.displayName);
        inputState.onValue(function () {
            field.Mutator.manual(inputState.value);
            // This will ensure topo map is updated (if it exists) and a user is updating vector locations
            point_collection_cache_1.TopologicalPointCollectionCache.dropCollectionVectors(field.collection.revision);
        });
        ctrl.changeState.addState(field.id, inputState);
        if (value != null) {
            inputState.setValue({
                distance: value.distance,
                bearing: value.bearing,
                pitch: value.pitch
            });
        }
    }
    // If none of the inputs are focused, and the field model value changes
    // the input state should also update.
    if (field.value !== null && !(inputState.distance.meters.focused ||
        inputState.distance.inch.focused ||
        inputState.distance.feet.focused ||
        inputState.bearing.focused)) {
        inputState.setValue(field.value);
    }
    var onmouseover = function () {
        page_state_1.CurrentState.setHoverId(field.id);
    };
    var onmouseout = function () {
        page_state_1.CurrentState.setHoverId(null);
    };
    var className = input_1.Input.CSS.container;
    return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover, onmouseout: onmouseout, onclick: onclick }, [
        vector_input_1.VectorInput.view(inputState)
    ]);
}
function viewManualEditButton(field) {
    return field_action_button_1.FieldActionButton.view({
        icon: icons_1.MaterialIcon.EDIT,
        text: index_1.T.FIELD_VECTOR_PROVIDER_MANUAL,
        onclick: function () { return field.Mutator.manual({ bearing: 0, distance: 0, pitch: 0 }); }
    });
}
function viewCollectionLinkButton(field, ctrl) {
    return field_action_button_1.FieldActionButton.view({
        icon: icons_1.MaterialIcon.SPAN_LINK,
        text: index_1.T.COLLECTION_LINK,
        linkingText: index_1.T.COLLECTION_LINK_CANCEL,
        linking: page_state_1.CurrentState.CollectionLink.isLinking,
        onclick: function () {
            if (page_state_1.CurrentState.CollectionLink.isLinking) {
                page_state_1.CurrentState.CollectionLink.cancelLinking();
                return;
            }
            linkCollection(field, ctrl);
        }
    });
}
exports.VectorManualFieldView = {
    viewInline: function (field) {
        if (!field.hasValue()) {
            return null;
        }
        var onmouseover = function () {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        var onmouseout = function () {
            page_state_1.CurrentState.setHoverId(null);
        };
        var className = input_1.Input.CSS.container;
        return (0, mithril_1.m)('div', { className: className, onmouseover: onmouseover, onmouseout: onmouseout, onclick: onclick }, [
            field_info_1.FieldInfo.viewVectorInline(field.value)
        ]);
    },
    hasDetail: function (field) {
        return false;
    },
    viewDetail: function (field) {
        return null;
    },
    viewEdit: function (field, ctrl) {
        if (field.hasValue()) {
            return viewVectorManualEdit(field, ctrl);
        }
        if (!(services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_COLLECTION_LINK)
            || services_1.Services.Token.has(core_api_1.IkeToken.FEATURE_GROUP_IKE_ANALYZE))) {
            return viewVectorManualEdit(field, ctrl);
        }
        var children = [];
        if (page_state_1.CurrentState.CollectionLink.isLinking) {
            if (page_state_1.CurrentState.CollectionLink.fieldId === field.id) {
                children.push(viewCollectionLinkButton(field, ctrl));
            }
        }
        else {
            children.push(viewManualEditButton(field));
            children.push(viewCollectionLinkButton(field, ctrl));
        }
        var onmouseover = function () {
            page_state_1.CurrentState.setHoverId(field.id);
        };
        var onmouseout = function () {
            page_state_1.CurrentState.setHoverId(null);
        };
        return (0, mithril_1.m)('div', { className: "".concat(CSS.container, " ").concat(CSS.isLinked), onmouseover: onmouseover, onmouseout: onmouseout }, children);
    }
};
//# sourceMappingURL=vector.manual.field.view.js.map